import { Component, inject, OnInit, viewChild } from '@angular/core';
import { NgForm, NgControl, FormsModule } from '@angular/forms';
import { DateWithNoTimeZonePipe } from '../../../pipes';
import { ModalService, RecordablesService } from '../../../services';
import { EmailMessage, Recordable } from '../../../types';
import { ModalformComponent } from '../../modalform/modalform.component';
import { switchMap, takeUntil } from 'rxjs/operators';
import { EditorModule } from 'primeng/editor';

import { ModalformModule } from '../../modalform/modalform.module';
import { UnsubscribeOnDestroy } from '../../../classes';


@Component({
    selector: 'emailrecordable',
    templateUrl: './emailrecordable.component.html',
    styleUrls: ['./emailrecordable.component.scss'],
    standalone: true,
    imports: [DateWithNoTimeZonePipe, ModalformModule, FormsModule, EditorModule]
})
export class EmailrecordableComponent extends UnsubscribeOnDestroy implements OnInit {
    emailAddresses: string;
    emailSubject: string;
    emailBody: string;
    recordable: Recordable;

    readonly modalForm = viewChild<ModalformComponent>("modalForm");
    readonly emailForm = viewChild<NgForm>("emailForm");
    readonly emailInput = viewChild<NgControl>("emailInput");

    private datePipe = inject(DateWithNoTimeZonePipe);
    private recordablesService = inject(RecordablesService);
    private modalService = inject(ModalService);

    constructor() {
        super();
    }

    ngOnInit(): void {
    }

    show(recordable: Recordable): void {
        this.recordable = recordable;
        this.emailForm().form.markAsPristine();
        this.emailAddresses = "";
        this.emailSubject = `Attention! Recordable records for: ${recordable.lot.streetAddress1} : ${recordable.community.orgName} (${recordable.community.sourceKey}) : ${recordable.lot.lotBlock}`;
        this.emailBody = `<div><b>Recordable Date:</b> ${this.datePipe.transform(recordable.recordableDate, "shortDate")}</div>
        <div><b>Recordable Category:</b> ${recordable.recordableCategoryDisplayName}</div>
        <div><b>Community:</b> ${recordable.communityDisplayName}</div>
        <div><b>Address:</b> ${recordable.lot.streetAddress1}</div>
        <div><b>Lot/Block:</b> ${recordable.lot.lotBlock}</div>
        <div><b>Task Name:</b> ${recordable.masterTaskDisplayName}</div>
        <div><b>Root Cause Vendor:</b> ${recordable.rootCauseVendorDisplayName}</div>
        <div><b>Recordable Description:</b> ${recordable.description}</div>`;

        if (this.recordable.attachments.length > 0) {
            this.emailBody += `<br><div><b>Attachments:</b></div>`;

            this.recordable.attachments.forEach(attachment => {
                this.emailBody += `<div><a #${attachment.id} href="">${attachment.fileName}</a></div>`;
            });
        }

        this.modalForm().confirmButtonText = "Send";
        this.modalForm().showModal = true;
    }

    sendEmail(): void {
        let emailMessage: EmailMessage = new EmailMessage();
        let recepients = this.emailAddresses.split(',');
        emailMessage.subject = this.emailSubject;
        emailMessage.htmlBody = this.emailBody;

        this.recordablesService.sendRecordableEmail(emailMessage, this.recordable, recepients)
            .pipe(
                takeUntil(this.ngUnsubscribe$),
                switchMap(x => this.modalService.showSuccessModal("Email was sent successfully"))
            )
            .subscribe(res => {
                this.resetForm();
                this.modalForm().showModal = false;
            });
    }

    updateValidationErrors(): void {
        this.emailInput().control.markAsDirty();
    }

    resetForm(): void {
        this.emailForm().resetForm();
    }


}
